import { IngestionStatus } from "@/shared/domain/files";

import type { StaticFilterField } from "./StaticFilterField";

export const INGESTION_STATUS_LABELS: Record<IngestionStatus, string> = {
  [IngestionStatus.Ingested]: "Ingested",
  [IngestionStatus.PartlyIngested]: "Partly ingested",
  [IngestionStatus.NotIngested]: "Not ingested",
};

// Spelled out rather than derived from `Object.values` so the dropdown reads
// most-ingested first. "Partly ingested" stays its own option because the two
// states differ in what they guarantee: `partly_ingested` means a topic was
// recorded against the file, while `ingested` means only that completion was
// reported, which is what post-ingestion triggers wait on.
export const INGESTION_STATUS_OPTIONS = [
  IngestionStatus.Ingested,
  IngestionStatus.PartlyIngested,
  IngestionStatus.NotIngested,
].map((value) => ({ label: INGESTION_STATUS_LABELS[value], value }));

/** The files table's filter rows, in picker order. */
export const FILE_FILTER_FIELDS = [
  { type: "string", field: "file_id", name: "File Id" },
  { type: "string", field: "name", name: "Name" },
  { type: "string", field: "relative_path", name: "Relative Path" },
  { type: "string", field: "description", name: "Description" },
  { type: "string", field: "uri", name: "URI" },
  { type: "string", field: "device_id", name: "Device Id" },
  { type: "string", field: "origination", name: "Source" },
  { type: "string", field: "upload_id", name: "Upload Id" },
  { type: "string", field: "association_id", name: "Association Id" },
  { type: "date", field: "created", name: "Created" },
  { type: "identity", field: "created_by", name: "Created By" },
  { type: "date", field: "modified", name: "Modified" },
  { type: "identity", field: "modified_by", name: "Modified By" },
  { type: "numeric", field: "size", name: "Size" },
  {
    type: "enum",
    field: "ingestion_status",
    name: "Ingestion Status",
    options: INGESTION_STATUS_OPTIONS,
    // `fs_nodes.ingestion_status` is NOT NULL, so IS_NULL would match no
    // file and IS_NOT_NULL every one. Neither belongs in the menu.
    nullable: false,
  },
  { type: "set", field: "tags", name: "Tags" },
] as const satisfies readonly StaticFilterField[];
